import styled from "styled-components";
import { Modal, Paper, Typography, Button } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

export const ModalMui = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const PaperMui = styled(Paper)`
  width: 100%;
  max-width: 380px;
  outline: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border-radius: 16px !important;
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
  background-color: #ffffff;
`;

export const Title = styled(Typography)`
  font-weight: 800 !important;
  color: ${theme.colors.base};
  font-size: 20px !important;
  text-align: center;
  margin-bottom: 24px !important;
`;

export const HighlightBox = styled.div`
  width: 100%;
  background-color: #f5f8fa;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  border: 1px dashed rgba(0, 0, 0, 0.1);
  box-sizing: border-box; /* 🎯 A SOLUÇÃO: Trava o tamanho para não vazar o Modal */
`;

export const SubConfirm = styled(Typography)`
  font-weight: 600 !important;
  color: #666666;
  font-size: 14px !important;
  margin-bottom: 8px !important;
`;

export const ValueHighlight = styled(Typography)`
  font-weight: 800 !important;
  color: ${theme.colors.base};
  font-size: 28px !important;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TransferIcon = styled(CurrencyExchangeIcon)`
  color: ${theme.colors.base};
  font-size: 28px !important;
`;

export const ContainerData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
  box-sizing: border-box;
`;

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 8px;
`;

export const SubTitle = styled(Typography)`
  font-weight: 600 !important;
  color: #888888;
  font-size: 14px !important;
`;

export const Message = styled(Typography)`
  font-weight: 700 !important;
  color: #333333;
  font-size: 14px !important;
  text-align: right;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
`;

export const CancelButton = styled(Button)`
  flex: 1;
  background-color: #f0f0f0 !important;
  color: #555555 !important;
  font-weight: bold !important;
  border-radius: 8px !important;
  text-transform: none !important;
  padding: 12px 0 !important;

  &:hover {
    background-color: #e4e4e4 !important;
  }
`;

export const ConfirmButton = styled(Button)`
  flex: 1;
  background-color: ${theme.colors.base} !important;
  color: #ffffff !important;
  font-weight: bold !important;
  border-radius: 8px !important;
  text-transform: none !important;
  padding: 12px 0 !important;

  &:hover {
    opacity: 0.9;
  }
`;
